import { render, staticRenderFns } from "./AttendanceItem.vue?vue&type=template&id=40d5e4b4&scoped=true&"
import script from "./AttendanceItem.vue?vue&type=script&lang=js&"
export * from "./AttendanceItem.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceItem.vue?vue&type=style&index=0&id=40d5e4b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d5e4b4",
  null
  
)

export default component.exports